import React from 'react';
import { Eye } from 'lucide-react';

export default function ImagePreview({ canvasRef, visible }) {
  if (!visible) return null;

  return (
    <div className="w-full bg-slate-800/50 backdrop-blur-md rounded-2xl border border-slate-700/50 p-6 animate-fade-in">
      <div className="flex items-center gap-2 mb-3">
        <Eye size={18} className="text-indigo-400" />
        <h3 className="text-lg font-semibold bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-cyan-400">
          Preview
        </h3>
      </div>
      <div className="w-full max-w-lg mx-auto border border-slate-700 rounded-lg overflow-hidden bg-slate-900">
        <canvas
          ref={canvasRef}
          className="block w-full h-auto max-h-80 object-contain"
          aria-label="Image preview showing conversion result with applied filters and settings"
        />
      </div>
      <p className="text-xs text-gray-500 mt-2 text-center">
        Preview reflects all selected options (scale, filters, crop).
      </p>
    </div>
  );
}
